// fetchdirectActions.js


import {
  SET_ALLCHECKOUTCONTEXTSELECT_DATA,
  SET_PAYMENTSELECT_METHODS,
  SET_BILLINGADDRESSSELECT_DATA,
  SET_SHIPPINGADDRESSSELECT_DATA,
  SET_PICKUPLOCATIONSSELECT_DATA,
} from './checkoutActions';






export const setAllCheckoutContextSelect = (checkoutselectcontext) => {
  // Speichern der Daten im Local Storage
  if (checkoutselectcontext) {
   // SidecartControl.saveCartToLocalStorage({ cartItems: cartData, supportsHTML5Storage });
  }
  
  return {
    type: SET_ALLCHECKOUTCONTEXTSELECT_DATA,
    payload: checkoutselectcontext
  };
};

export const setSelectPaymentMethods = (selectpaymentmethod) => ({
  type: SET_PAYMENTSELECT_METHODS,
  payload: selectpaymentmethod
});

export const setSelectBillingAddress = (selectbillingaddress) => ({
  type: SET_BILLINGADDRESSSELECT_DATA,
  payload: selectbillingaddress
});

export const setSelectShippingAddress = (selectshippingaddress) => ({
  type: SET_SHIPPINGADDRESSSELECT_DATA,
  payload: selectshippingaddress
});

export const setSelectPickuplocations = (selectpickuplocations) => ({
  type: SET_PICKUPLOCATIONSSELECT_DATA,
  payload: selectpickuplocations
});